import { routerReducer } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware, StoreEnhancer } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import auth from './reducers/Auth';
import app from './reducers/App';
import moffAPI from './reducers/MoffApi';
import header from './reducers/Header';
// import error from './reducers/Error';

import { reducer as formReducer } from 'redux-form';

const loggerMiddleware = createLogger;
let middleware: StoreEnhancer;

if (process.env.NODE_ENV !== 'production') {
  // 開発.
  middleware = applyMiddleware(
    thunkMiddleware,
    loggerMiddleware,
  );
} else {
  // 製品版はログを使わない.
  middleware = applyMiddleware(
    thunkMiddleware,
  );
}

const configureStore = () => {
  return createStore(
    combineReducers({
      app: app,
      auth: auth,
      header: header,
      moffAPI: moffAPI,
      // error: error,
      // signFormの formとの連携
      form: formReducer,
      routing: routerReducer,
    }),
    middleware
  );
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.tsx